import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class DockAppointments_ds_find_dockappointmentitemsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { statusIds?: number[], entityType?: string, entityIds?: number[] }): 
  Promise<{ result: { Id?: number, ItemEntityId?: number, ItemEntityType?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_find_dockappointmentitems/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { statusIds?: number[], entityType?: string, entityIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ItemEntityId?: number, ItemEntityType?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_find_dockappointmentitems/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { statusIds?: number[], entityType?: string, entityIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, ItemEntityId?: number, ItemEntityType?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_find_dockappointmentitems/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
